import { MultiSelect } from '@library/components/selects';
import type { SelectOption } from '@library/types/utils';

export interface MultiSelectFilterProps {
  allOption?: boolean;
  customHeight?: string;
  disabled?: boolean;
  onChange: (value: Array<string>) => void;
  label?: string;
  options: Array<SelectOption>;
  portal?: boolean;
  returnAll?: boolean;
  selectedValues: Array<string>;
  size?: 'small' | 'medium';
  showTags?: boolean;
  testId?: string;
}

export const MultiSelectFilter = ({
  allOption = true,
  customHeight = '',
  disabled = false,
  onChange,
  portal = false,
  label = '',
  returnAll = false,
  selectedValues,
  showTags = false,
  options,
  size = 'small',
  testId = 'multiselect-filter'
}: MultiSelectFilterProps) => {
  const handleMultiSelect = (value: Array<SelectOption>) => {
    const newSelectedValues =
      options.length === value.length && !returnAll
        ? []
        : value.map((option) => option.value);

    onChange(newSelectedValues);
  };

  return (
    <MultiSelect
      allowSelectNone={returnAll}
      allOption={allOption}
      customHeight={customHeight}
      disabled={disabled}
      onChange={handleMultiSelect}
      portal={portal}
      label={label}
      options={options}
      size={size}
      showTags={showTags}
      testId={testId}
      values={selectedValues}
    />
  );
};
